import React from 'react';
import LogoTA from '../../images/TALOGO.png';
const logoLoginRole = (props) => (
    <span style={{ marginRight: '55px' }} className="logo-lg"><img className="loginRole" style={{ width: '250px' }} src={LogoTA} /></span>
);
export default logoLoginRole;



// WEBPACK FOOTER //
// ./src/components/Logo/LogoLoginRole.js